module.exports = __webpack_public_path__ + "img/143.ca610f7f.jpg";